<div class="wrapper">
  <input
    #input
    [type]="type"
    [id]="uniqueId"
    [readonly]="!isEditable"
    [placeholder]="placeholder"
    [ngClass]="[theme, variant, inlineEdit ? 'inlineEditInput' : '']"
    [autocomplete]="autocomplete"
    [value]="value"
    [disabled]="disabled"
    (input)="onChange($event.target.value)"
    (focus)="focused()"
    (blur)="blurred()"
  />

  <div class="actions" *ngIf="inlineEdit">
    <ng-container *ngIf="!isEditable">
      <studio-button-legacy (click)="edit()" class="edit-button" theme="transparent">{{
        editButtonText
      }}</studio-button-legacy>
    </ng-container>

    <ng-container *ngIf="isEditable">
      <studio-button-legacy (click)="cancel()" class="cancel-button" theme="transparentError"
        >Cancel</studio-button-legacy
      >
      <studio-button-legacy
        class="save-button"
        theme="transparent"
        type="submit"
        (click)="save()"
        [disabled]="!isValid"
        >Save</studio-button-legacy
      >
    </ng-container>
  </div>
  <ng-content></ng-content>
</div>
